import { isOnboardingButton } from "@/shared/lib/onboarding-session"
import { FAQ_SECTION_IDS } from "@/shared/router"

// Launch parameters and query strings are user-editable, so only identifiers the app itself acts on are recorded.

/** Start-param `tab` values handled by the deep-link wrapper, moderation settings, group settings and the FAQ. */
const START_TABS: ReadonlySet<string> = new Set([
  "user-profile",
  "user-settings",
  "leaderboard",
  "ai-business-mode",
  "statistic",
  "welcome",
  "ad-grid",
  "ad-business",
  "clone-create",
  "api-key",
  "reports",
  "appeals",
  "event_journal",
  "statistics",
  "captcha",
  "folder-join",
  "ai-antispam",
  "blacklist",
  "whitelist",
  "rules-message",
  "greeting-message",
  "farewell-message",
  "auto-messages",
  "subscription",
  "subscription-plans",
  "permissions",
  "ranks",
  "prompts",
  "documents",
  "faq",
  ...FAQ_SECTION_IDS.map(section => `faq-${section}`)
])

/** `?tab=` values of the URL-backed tabbed pages: reports, the AI learning pipeline and legacy Celestia Pro links. */
const URL_TABS: ReadonlySet<string> = new Set([
  "open",
  "history",
  "overview",
  "learning",
  "publication",
  "support-pro",
  "ai-business-mode",
  "multi-bot"
])

export const knownStartTab = (tab: string): string => (START_TABS.has(tab) ? tab : "other")

export const knownUrlTab = (tab: string | null): string | null => (tab !== null && URL_TABS.has(tab) ? tab : null)

export const knownOnboardingButton = (button: string): string => (isOnboardingButton(button) ? button : "other")
